import React from 'react';
import PropTypes from 'prop-types';
import Tools from './Tools.jsx'

function Toolbar({
  toolsProps
}) {
  return (
    <div>
      <Tools {...toolsProps} />
    </div>
  );
}

Toolbar.defaultProps = {};

Toolbar.propTypes = {
  toolsProps: PropTypes.object
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Admin/UserSponsor/Toolbar/index.jsx